import React, { useRef, isValidElement } from 'react';
export default function CustomHtmlRender(props) {
    const { renderHtml, topLevelAttributes = {}, ...otherProps } = props;
    const ref = useRef(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const customElement = renderHtml(otherProps);
    const isDomElement = customElement instanceof HTMLElement;
    const isReactNode = isValidElement(customElement);
    if (isDomElement && ref.current) {
        ref.current.innerHTML = ''; // Clear previous content
        ref.current.appendChild(customElement);
    }
    if (isReactNode) {
        return customElement;
    }
    if (isDomElement) {
        return React.createElement("div", { ...topLevelAttributes, ref: ref });
    }
    return null;
}
